import { createSlice } from '@reduxjs/toolkit';
import { getOverviewData } from '../../thunks/admin/overview';

export const overviewSlice = createSlice({
  name: 'overview',
  initialState: {
    isLoading: false,

    income: 0,
    credits: 0,
    expenses: {
      employees: {
        current: 0,
        expected: 0,
      },
      other: 0,
    },
    profit: {
      current: 0,
      expected: 0,
    },

    hours: {
      paid: 0,
      credit: 0,
      worked: 0,
      remaining: 0,
      total: 0,
    }
  },

  reducers: {},

  extraReducers: {
    [getOverviewData.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getOverviewData.fulfilled]: (state, action) => {
      const {
        income,
        credits,
        expenses,
        profit,
        hours,
      } = action.payload;

      state.income = income;
      state.credits = credits;
      state.expenses = expenses;
      state.profit = profit;
      state.hours = hours;
      state.isLoading = false;
    },
    [getOverviewData.rejected]: (state, action) => {
      state.isLoading = false;
    },
  }
});

// export const {  } = overview.actions;

export default overviewSlice.reducer;
